import type { FireIconProps } from './types';

export default function Aed({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Case */}
      <rect x="3" y="4" width="18" height="16" rx="2" />
      {/* Heart */}
      <path d="M12 9c-1-2-4-2-4 0s4 5 4 7c0-2 4-5 4-7s-3-2-4 0z" />
      {/* Lightning bolt */}
      <path d="M13 11l-1 2h2l-1 2" />
      {/* Handle */}
      <path d="M8 4V2h8v2" />
    </svg>
  );
}
